import * as defaultImport from "@splunk/react-ui/File";
export * from "@splunk/react-ui/File";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
